import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app.jsx';
import { getRootElement } from './config/root';

createRoot(getRootElement()).render(
  <StrictMode>
    <App />
  </StrictMode>
);
